<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-none element-without-heading" id="uncategorized">
<div class="text" id="uncategorized-text">
<p class="first first-in-chapter first-full-width">I was born at the crossing of the white church*<sup><a class="endnote-source" href="#/epigraph2#uncategorized-endnote-1-text" id="uncategorized-endnote-1">1</a></sup></p>
<p class="subsq">In the shadow of the black mountain.</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width">Where the walls bleed broken bottles</p>
<p class="subsq">And the barbed-wire binds the fountain.</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width">I grew up with the promise of the chosen,</p>
<p class="subsq">Shouldered the banners of the certain,</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width">Was cut down by the falseness of prophets,</p>
<p class="subsq">Abandoned by the truth everlasting.</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width">Laughed in the faces of the fallen,</p>
<p class="subsq">Was banished to the valley of not knowing.</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width">Mad dogs, King Rats, Butchers,</p>
<p class="subsq">Sheebeens of wickedness and of self-loathing.</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width">I was born at the crossing of the white church</p>
<p class="subsq">In the shadow of the black mountain</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width">Where the wild things burn their young</p>
<p class="subsq">And the sparks rise up to heaven.</p>
</div>
<div class="endnotes">
<div class="endnotes-separator">
</div>
<div class="endnote-text" id="uncategorized-endnote-1-text"><p class="first"><span class="endnote-text-number"><a class="endnote-backlink" href="#/epigraph2#uncategorized-endnote-1">1</a> </span><i>* Shankill (‘Old Church’) was otherwise formally ‘the church of the white crossing’ (Ecclesia alba de vado).</i></p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph-2.vue?280b6a65